<template>
	<div id="login-registration-modal">
		<div class="tabs">
			<div class="tab" @click="showTab('login')" :class="{ active: currentTab === 'login' }">{{ $t("user.login") }}</div>
			<div class="tab" @click="showTab('registration')" :class="{ active: currentTab === 'registration' }">{{ $t("user.registration") }}</div>
		</div>
		<div class="tabs-content">
			<div class="tab-content" v-if="currentTab === 'login'"><LoginTab /></div>
			<div class="tab-content" v-if="currentTab === 'registration'"><RegistrationTab /></div>
		</div>
	</div>
</template>

<script>
	import LoginTab from "./LoginTab";
	import RegistrationTab from "./RegistrationTab";

	export default {
		name: "LoginRegistrationModalContent",
		props: {
			initTab: {
				type: String,
				default: "login"
			}
		},
		data() {
			return {
				currentTab: "login",
			};
		},
		components: {
			RegistrationTab, LoginTab
		},
		mounted() {
			this.currentTab = this.initTab;
		},
		methods: {
			showTab(tab) {
				this.currentTab = tab;
			}
		}
	}
</script>

<style lang="scss" scoped>
	#login-registration-modal {
		width: 100%;
		height: 390px;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		.tabs {
			background-color: rgba(255, 255, 255, 0.21);
			height: 50px;

			.tab {
				float: left;
				width: 50%;
				height: 50px;
				text-align: center;
				line-height: 50px;
				color: rgba(254, 254, 254, 0.75);
				cursor: pointer;

				&:hover {
					background-color: rgb(44, 70, 82);
				}

				&.active {
					background-color: rgb(44, 70, 82);
				}
			}
		}

		.tabs-content {
			padding-top: 20px;
			clear: both;
			height: 450px;
			overflow-y: auto;
			overflow-x: hidden;
		}
	}
</style>
